import { CommonModule } from '@angular/common';
import { Component, Inject, type OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent {
  constructor(
    private dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      titleIcon: string;
      title: string;
      message: string;
      confirmText: string;
      cancelButton: string;
    } = {} as any
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }
  onDismiss() {
    this.dialogRef.close(false);
  }
}
